import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-grid p-m-2" }
const _hoisted_3 = { class: "p-col-3" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "p-col-2" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "qbe-filter-option-value" }
const _hoisted_9 = { class: "p-col-2" }
const _hoisted_10 = { class: "kn-material-input-label" }
const _hoisted_11 = { class: "p-col-3" }
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_14 = { class: "p-col-2" }
const _hoisted_15 = { class: "kn-material-input-label" }
const _hoisted_16 = { class: "p-d-flex p-flex-row p-ai-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.having)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.field')), 1),
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.having.leftOperandDescription,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.having.leftOperandDescription = $event)),
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t('qbe.filters.condition')), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.$t('qbe.filters.conditionTooltip'),
                void 0,
                { top: true }
              ]
            ]),
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.having.operator,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.having.operator = $event)),
              options: _ctx.QBEHavingDialogDescriptor.operatorValues,
              optionValue: "value"
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("span", _hoisted_8, _toDisplayString(slotProps.value.toLowerCase()), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('qbe.filters.targetType')), 1),
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.having.rightType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.having.rightType = $event)),
              options: _ctx.targetValues,
              optionValue: "value",
              optionLabel: "label",
              onChange: _ctx.onHavingTypeChange
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('qbe.filters.target')), 1),
            _createVNode("div", _hoisted_13, [
              (_ctx.having.rightType === '')
                ? (_openBlock(), _createBlock(_component_InputText, {
                    key: 0,
                    class: "kn-material-input",
                    modelValue: _ctx.having.rightOperandDescription,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.having.rightOperandDescription = $event)),
                    onInput: _ctx.onManualValueChange
                  }, null, 8, ["modelValue", "onInput"]))
                : (_ctx.having.rightType === 'anotherEntity')
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 1,
                      class: "kn-material-input kn-flex",
                      modelValue: _ctx.having.rightOperandDescription,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.having.rightOperandDescription = $event)),
                      options: _ctx.entities,
                      optionLabel: "field",
                      optionValue: "id",
                      onChange: _ctx.onEntityTypeChanged
                    }, null, 8, ["modelValue", "options", "onChange"]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('qbe.filters.target')), 1),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input kn-flex",
                modelValue: _ctx.having.booleanConnector,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.having.booleanConnector = $event)),
                options: _ctx.QBEHavingDialogDescriptor.booleanConnectors
              }, null, 8, ["modelValue", "options"]),
              _createVNode("i", {
                class: "fa fa-eraser kn-cursor-pointer p-ml-2",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('removeHaving', _ctx.having)))
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}